import React from 'react';
import { siteConfig } from '../../config/siteConfig';
import NewsletterBanner from '../NewsletterBanner/NewsletterBanner';
import './Footer.css';

const Footer = () => {
  const { footer, contact } = siteConfig;

  return (
    <footer className="footer">
      {/* Newsletter Banner - Now appears on all pages */}
      <NewsletterBanner />

      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          
          {/* Contact Section */}
          <div className="footer-contact">
            {/* Contact Us Scrolling Text */}
            <div className="contact-banner">
              <div className="scrolling-text contact-scroll" data-speed={footer.contactScrolling.speed}>
                                  <span className="contact-text">
                    {Array(15).fill(null).map((_, index) => (
                      <span key={index} className={index === 1 ? 'solid' : 'outline'}>
                        {footer.contactScrolling.text}&nbsp;
                      </span>
                    ))}
                  </span>
              </div>
            </div>

            {/* Contact Information */}
            <div className="contact-info">
              <div className="contact-address">
                <p>{contact.address.street}, {contact.address.city}</p>
                <p>{contact.phone}</p>
                <p><a href={`mailto:${contact.email}`}>{contact.email}</a></p>
              </div>

              {/* Social Media Links */}
              <div className="social-links">
                {Object.entries(contact.social).map(([key, social]) => (
                  <a 
                    key={key}
                    href={social.url} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    className="social-link"
                    aria-label={social.name}
                  >
                    <i className={social.icon}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Partner Logos Section */}
          <div className="footer-partners">
            <div className="partner-logos">
              {footer.partnerLogos.map((partner, index) => (
                <a 
                  key={index}
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="partner-link"
                >
                  <img 
                    src={partner.src}
                    alt={partner.alt}
                    className="partner-logo"
                  />
                </a>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-container">
          <div className="footer-bottom-content">
            
            {/* Powered By */}
            <div className="powered-by">
              <span>{footer.poweredBy.text} </span>
              <a href={footer.poweredBy.url} target="_blank" rel="noopener noreferrer">
                {footer.poweredBy.company}
              </a>
            </div>

            {/* Copyright */}
            <div className="copyright">
              <span>©{footer.copyright.year} {footer.copyright.company}. {footer.copyright.text}</span>
            </div>

            {/* Legal Links */}
            <div className="legal-links">
              {footer.legalLinks.map((link, index) => (
                <span key={index}>
                  <a href={link.url} className="legal-link">{link.name}</a>
                  {index < footer.legalLinks.length - 1 && ' | '}
                </span>
              ))}
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 